var EvaluationService = {
  initialize: function(evaluationMap) {
    evaluationMap = (evaluationMap || {});
    this.mapping = evaluationMap;
  },

  getResponseSet: function(courseSlug) {
    let responseSet = {
      id: 'local',
      token: 'not-real',
      endpoint: 'http://nowhere.dev'
    };
    let fakeResponseSet = { id: 'local', token: 'not-real', endpoint: 'http://nowhere.dev' };
    if(this.mapping && this.mapping[courseSlug]) {
      return this.mapping[courseSlug];
    } else {
      return fakeResponseSet;
    }
  },

  userHasCompletedEvaluation: function(courseSlug) {
    const responseSet = this.findEvaluationBySlug(courseSlug);
    if(responseSet) {
      var completed = responseSet.get('status') === 'completed';
      if(completed) {
        this.refreshResponseSet(courseSlug);
      }
      return completed;
    }
  },

  shouldSkip: function(slug) {
    var responseSet = this.getResponseSet(slug);
    var evaluation = this.findEvaluationBySlug(slug);
    return evaluation && evaluation.get('can_be_skipped') && responseSet && responseSet.status && responseSet.status === 'skipped';
  },

  getResponseSetFromModel: function(courseSlug) {
    var evaluation = this.findEvaluationBySlug(courseSlug);
    const responseSet = evaluation ? evaluation.get('responseSet') : null;

    if(responseSet) {
      responseSet.endpoint = evaluation.get('endpoint');
      responseSet.id = evaluation.get('id');
    }
    return responseSet;
  },

  findEvaluationBySlug: function(slug) {
    var courseSlugId = this.mapping[slug] ? this.mapping[slug].id : null;
    return courseSlugId ? EF.responseSet.models.find((model) => { return model.get('id') === courseSlugId; }) : null;
  },

  findEvaluationTokenBySlug: function(slug) {
    return this.mapping[slug].token;
  },

  refreshResponseSet: function(slug) {
    const responseSet = this.findEvaluationBySlug(slug);
    if(responseSet) {
      let options = EF.options.local ? {} : {
          parse: true,
          headers: {'Authorization': `Bearer ${responseSet.get('token')}`}
        };
      responseSet.fetch(options);
    }
  },

  bestScore: function(courseSlug) {
    var responseSet = this.getResponseSetFromModel(courseSlug);
    return responseSet ? responseSet.grade: 0;
  }
};

module.exports = EvaluationService;
